import { DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import SubmitButton from "./button/SubmitButton"
import { useDispatch, useSelector } from 'react-redux'
import { closeModal } from "../store/actions/modalAction"
import CustomDialog from "./layouts/common/CustomDialog"

const MessageDilog = ({ title = "Error", message, onSubmit, loading, confirmText, modalKey, id = "error" }) => {
    const dispatch = useDispatch()
    const data= useSelector((state)=> state.loading)
    const handleClose = () => {
        dispatch(closeModal())
    }
    console.log("data loading", data)
    return (
        <>
            <CustomDialog
                id={id ?? 'error'}
                loading={loading ?? data?.loading}
                onClose={handleClose}
                onSubmit={onSubmit ? onSubmit : handleClose}
                title={title}
                closeText="Close"
                confirmText={confirmText ?? `okay`}
            >

                {message}
            </CustomDialog>


        </>
    )
}
export default MessageDilog